import { render, staticRenderFns } from "./VueBubblyBg.vue?vue&type=template&id=22788956&scoped=true&"
import script from "./VueBubblyBg.vue?vue&type=script&lang=js&"
export * from "./VueBubblyBg.vue?vue&type=script&lang=js&"
import style0 from "./VueBubblyBg.vue?vue&type=style&index=0&id=22788956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22788956",
  null
  
)

export default component.exports